class LoadMoreCollection {
  constructor() {
    this.productGrid = document.getElementById('product-grid');
    this.paginationWrapper = document.querySelector('.pagination-wrapper');
    if (!this.productGrid || !this.paginationWrapper) return;

    this.nextLink = this.paginationWrapper.querySelector('a[aria-label="Next page"]')
             || this.paginationWrapper.querySelector('a[rel="next"]')
             || this.paginationWrapper.querySelector('.pagination__item--next')
             || this.paginationWrapper.querySelector('.pagination__item-arrow:last-of-type');
    if (!this.nextLink) return;

    this.isLoading = false;
    this.hasMore = true;
    this.totalProducts = this.getTotalProducts();
    this.loadedProducts = this.productGrid.querySelectorAll(':scope > li').length;

    this.injectLoadMoreUI();
    this.bindEvents();
  }

  getTotalProducts() {
    // Try to read total from a known Dawn element; fallback to null
    const facetForm = document.getElementById('CollectionProductGrid');
    if (facetForm && facetForm.dataset.totalProducts) {
      return parseInt(facetForm.dataset.totalProducts, 10);
    }
    // Look for "Showing X of Y" style markers some themes include
    return null;
  }

  injectLoadMoreUI() {
    this.wrapper = document.createElement('div');
    this.wrapper.className = 'load-more-wrapper';

    // Optional count indicator
    if (this.totalProducts) {
      this.countLabel = document.createElement('span');
      this.countLabel.className = 'load-more-count';
      this.updateCount();
      this.wrapper.appendChild(this.countLabel);
    }

    // The button itself
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'load-more-button';
    this.button.setAttribute('aria-label', 'Load more products');
    this.button.innerHTML = `
      <span class="load-more-button__text">Load More</span>
      <span class="load-more-button__spinner" role="status" aria-hidden="true"></span>
    `;
    this.wrapper.appendChild(this.button);

    // End-of-collection marker (hidden initially)
    this.endMarker = document.createElement('div');
    this.endMarker.className = 'load-more-end';
    this.endMarker.setAttribute('aria-live', 'polite');
    this.endMarker.textContent = "You've reached the end of this collection";

    // Insert before the (hidden) pagination wrapper
    this.paginationWrapper.parentNode.insertBefore(this.wrapper, this.paginationWrapper);
    this.paginationWrapper.parentNode.insertBefore(this.endMarker, this.paginationWrapper);
  }

  updateCount() {
    if (!this.countLabel || !this.totalProducts) return;
    this.countLabel.textContent = `Showing ${this.loadedProducts} of ${this.totalProducts} products`;
  }

  bindEvents() {
    this.button.addEventListener('click', () => this.loadNextPage());
  }

  async loadNextPage() {
    if (!this.nextLink || this.isLoading || !this.hasMore) return;

    this.isLoading = true;
    this.button.classList.add('is-loading');
    this.button.disabled = true;
    const originalText = this.button.querySelector('.load-more-button__text').textContent;
    this.button.querySelector('.load-more-button__text').textContent = 'Loading';

    const url = this.nextLink.href;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.getElementById('product-grid');
      if (!newGrid) {
        this.markEnd();
        return;
      }

      const newProducts = newGrid.querySelectorAll(':scope > li');
      const firstNewProduct = newProducts[0];

      newProducts.forEach((product) => {
        this.productGrid.appendChild(document.importNode(product, true));
      });

      this.loadedProducts += newProducts.length;
      this.updateCount();

      // Move keyboard focus to the first newly loaded product for accessibility
      if (firstNewProduct) {
        const firstAppended = this.productGrid.querySelector(`#${CSS.escape(firstNewProduct.id)}`)
                            || this.productGrid.querySelectorAll(':scope > li')[this.loadedProducts - newProducts.length];
        if (firstAppended) {
          const focusable = firstAppended.querySelector('a, button');
          if (focusable) {
            focusable.setAttribute('tabindex', '-1');
            focusable.focus({ preventScroll: true });
          }
        }
      }

      // Update the next link from the fetched page
      const newPagination = doc.querySelector('.pagination-wrapper');
const newNextLink = newPagination
  ? (newPagination.querySelector('a[aria-label="Next page"]')
     || newPagination.querySelector('a[rel="next"]')
     || newPagination.querySelector('.pagination__item--next')
     || newPagination.querySelector('.pagination__item-arrow:last-of-type'))
  : null;

      if (newNextLink && newNextLink.href) {
        this.nextLink = newNextLink;
        this.button.querySelector('.load-more-button__text').textContent = originalText;
      } else {
        this.markEnd();
      }

    } catch (error) {
      console.error('Load More error:', error);
      this.button.querySelector('.load-more-button__text').textContent = 'Try Again';
      this.hasMore = true; // allow retry
    } finally {
      this.isLoading = false;
      this.button.classList.remove('is-loading');
      this.button.disabled = false;
    }
  }

  markEnd() {
    this.hasMore = false;
    this.wrapper.classList.add('is-hidden');
    this.endMarker.classList.add('is-visible');
  }
}

// Initialize on load and on Shopify theme-editor section reloads
function initLoadMore() {
  new LoadMoreCollection();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoadMore);
} else {
  initLoadMore();
}

// Re-init when Shopify section reloads in theme editor
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('#product-grid')) {
    initLoadMore();
  }
});